import { useAdminModeContext } from '@modules/App/providers/AdminModeProvider'
import { useOffersQuery } from '@queries/useOffersQuery'

import { getSamplesOffersQueryParams } from '../utils/getSamplesOffersQueryParams'

export type UseSamplesOffersQueryOptions = {
  size?: number
  query?: string
}

export const useSamplesOffersQuery = (options?: UseSamplesOffersQueryOptions) => {
  const adminMode = useAdminModeContext()
  const { offersQuery } = useOffersQuery([
    getSamplesOffersQueryParams({
      includeFulfillmentService: !adminMode?.isActive,
      ...options,
    }),
  ])

  return {
    offersQuery,
  }
}
